/** 页面信息 */
const page = new (function () {
  this.title = '企业档案信息表'
  this.icon = 'iconfont iconicon_group'
  this.name = 'archive'
  /**菜单编号 */
  this.code = 'archive'
  /**菜单别名 */
  this.aliasName = 'menu'
  /**路由地址 */
  this.path = '/register/archive'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
